<template>
<div>
    <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  <v-data-table
    :headers="headers"
    :items="role_type_master_list"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-toolbar-title>Role type</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">Add Role type</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-select 
                      :items="role_typ_super_master_list"
                      v-model="editedItem.role_type"
                      item-text="role_typ_super_master_list"
                      item-value="id"
                      persistent-hint
                      :disabled="editedIndex != -1"
                      :hint="editedIndex==-1?'For example :: Male, Female':'For example :: Male, Female'"
                      :filled="editedIndex==-1?false:true"
                      label="Role Type"
                      :error="errorMsg.role_type?true:false"
                      :error-messages="errorMsg.role_type?'Required':''"
                    ></v-select>
                  </v-col>
                   <v-col cols="12" sm="6" md="4" v-if='editedIndex != -1'>
                    <v-checkbox
                        dense
                        v-model="editedItem.isactive"
                        color="success"
                        label="Active"
                      ></v-checkbox>
                  </v-col>     
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="primary darken-1"  @click="save">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

         <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
              <v-icon  class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon  class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>

    <template v-slot:item.action="{ item }">
     <div>
        <v-avatar style="" size="25" class="edit-avatar">
          <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
       </v-avatar>
      </div>
      <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
    </template>
    <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
  </v-data-table>
</div>
</template>

<script>
import axios from 'axios'
  export default {
    data: () => ({
      role_type:['role 1','Role 2','Role 3'],
      errorMsg:{
        role_type:false
      },
      snackbar: false,
      search:'',
      dialog: false,
      search:'',
      dialog: false,
      headers: [
        {
          text: 'Role Type',align: 'left',sortable: false,value: 'role_type',
        },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      role_type_master_list: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        role_type: '',
        isactive:true  
      },
      defaultItem: {
        id: '',
        role_type: '',
        isactive:true      
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Role Type' : 'Edit Role type'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    // created () {
    //   this.initialize()
    // },
    mounted(){
      axios
      .post("/AdmissionMaster/role_type")
      .then(res => {
        if (res.data.msg == "200") {
          //window.alert(res.data.msg)
          this.role_type_master_list = res.data.role_type_master_list
          this.role_typ_super_master_list=res.data.role_typ_super_master_list
          this.load = true;
        } else {
          window.console.log(res.data.msg)
        }
      })
      .catch(error => {
        window.console.log(error);
      });
     },
    methods: {
    //   initialize () {
        
    //   },

      editItem (item) {
        this.editedIndex = this.role_type_master_list.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
       showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
      // deleteItem (item) {
      //   const index = this.role_type_master_list.indexOf(item)
      //   confirm('Are you sure you want to delete this item?') && this.role_type_master_list.splice(index, 1)
      // },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) 
        {
          if(this.isValidated())
         {
          axios
          .post("/AdmissionMaster/editRoleType", this.editedItem)
          .then(res => {
            if (res.data.msg == "200") {
              //window.alert(res.data.msg)
              Object.assign(this.role_type_master_list[this.editedIndex], this.editedItem)
            }
               this.showSnackbar(
                  "#4caf50",
                  "Role type Updated Successfully..."
                ); // show snackbar on success
          })
          .catch(error => {
            window.console.log(error);
          });
            this.close()
         }
        } 
        else 
        {
          if(this.isValidated())
         {
          this.role_type_master_list.push(this.editedItem)
           axios
          .post("/AdmissionMaster/saveRoleType", this.editedItem)
          .then(res => {
            if (res.data.status.code == "SUCCESS") {
            //window.alert(res.data.status.code)
            this.role_type_master_list.push(this.editedItem)
             this.showSnackbar("#4caf50", "Role Type Added Successfully!!!"); // show snackbar on success            
            }
            else if(res.data.status.code == "NA"){
                //window.alert(res.data.status.code)
                 this.showSnackbar("#b71c1c", "Role Type Already Present!!!"); // show snackbar on error
            }
          })
          .catch(error => {
            window.console.log(error);
          });
          this.close()
         }
        }
      }, //save()
      isValidated(){
      if(this.editedItem.role_type)
       { 
           return true; 
       }
      else{
            if(!this.editedItem.role_type)
            {
              this.errorMsg.role_type=true
            }
           
        return false;
      }  
     }, // .....end of isValidated()
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>